export var UpdatedOperationType;
(function (UpdatedOperationType) {
    UpdatedOperationType[UpdatedOperationType["CounselingOrIndividualSupport"] = 1] = "CounselingOrIndividualSupport";
    UpdatedOperationType[UpdatedOperationType["Education"] = 2] = "Education";
    UpdatedOperationType[UpdatedOperationType["GroupActivities"] = 3] = "GroupActivities";
    UpdatedOperationType[UpdatedOperationType["Communication"] = 4] = "Communication";
    UpdatedOperationType[UpdatedOperationType["PromotionOfInterestsAndInfluencing"] = 5] = "PromotionOfInterestsAndInfluencing";
    UpdatedOperationType[UpdatedOperationType["Other"] = 6] = "Other";
})(UpdatedOperationType || (UpdatedOperationType = {}));
